import AScene from "../../library/ExtendedObjects/AScene.js";
import gameData from "../../gameData.js";
import ASpine from "../../library/ExtendedObjects/ASpine.js";
import Game from "./Game.js";

export default class Game_PigAnimations
{
    /**
     * @param {Game} scene 
     */
    constructor(scene)
    {
        this.scene = scene;
    }

    /**
     * @param {ASpine} pig 
     */
    playAnimation(pigKey, pig, onComplete)
    {
        this.pig = pig;
        this.pigData = gameData.pigs[pigKey];
        this.onComplete = onComplete;

        switch (this.pigData) {
            case gameData.pigs.flyingPig:
                this.animateUniPig();
                break;
            case gameData.pigs.pilotPig:
                this.animateFlyingPig();
                break;
            case gameData.pigs.thiefPig:
                this.animateThiefPig();
                break;
            case gameData.pigs.punkPig:
            case gameData.pigs.knightPig:
            case gameData.pigs.princessPig:
                this.animateRegular();
                break;
            case gameData.pigs.richPig:
                this.animateRichPig();
                break;
            case gameData.pigs.ninjaPig:
                this.animateNinjaPig();
                break;
            case gameData.pigs.merPig:
                this.animateMermaid();
                break;
            case gameData.pigs.piratePig:
                this.animatePiratePig();
                break;
        }
    }

    animateUniPig()
    {
        this.animateFlyingPig();

        let sparkleEmitter = this.scene.addEmitter({
            x: {min: -300, max: -300}, y: 300,
            gravityY: 200,
            speedX: {min: -50, max: 50},
            lifespan: 3000,
            alpha: {start: 1, end: 0, ease: Phaser.Math.Easing.Expo.In},
            scale: {min: .2, max: .6},
            bounds: new Phaser.Geom.Rectangle(0, 300, 1024, 400),
            bounce: {min: .3, max:.6},
            tint: [0xfd2dff, 0x952dff, 0xfd2dff],
            blendMode: "ADD"
        }, "Sprkl_1");
        this.xVal = -200;
        this.scene.addTween(this, 3000, {xVal: this.scene.mid.x, onUpdate: ()=>{
            sparkleEmitter.x.end = this.xVal + 100;
            sparkleEmitter.x.start = this.xVal - 100;
        }}, null, ()=>{
            sparkleEmitter.stop();
        });

    }

    animatePiratePig()
    {
        this.pig.spine.alpha = 0;
        this.scene.addDelay(800, () => {
            this.pig.play(this.pigData.animation, false, null, 1.3);
            this.pig.spine.setPosition(this.pigData.pigPos.x, - 100);
            this.pig.spine.alpha = 1;

            this.scene.addTween(this.pig.spine, 1500, { y: this.pigData.pigPos.y, easeParams: [1, .9] }, "Elastic", () => { this.onComplete(); });
            this.scene.addDelay(200, () => {
                this.createSplash();
            });
        });
    }

    animateMermaid()
    {
        this.pig.spine.alpha = 0;
        this.scene.addDelay(800, () => {
            this.pig.play(this.pigData.animation, false, null, 1.3);
            this.pig.spine.setPosition(this.pigData.pigPos.x, - 100);
            this.pig.spine.alpha = 1;

            this.scene.addTween(this.pig.spine, 1500, { y: this.pigData.pigPos.y, easeParams: [1, .9] }, "Elastic", () => { this.onComplete(); });
            this.scene.addDelay(200, () => {
                this.createSplash();
            });
        });
    }

    createSplash()
    {
        for(let i = 0; i < 20; i++)
        {
            this.scene.addDelay(i * 15, ()=>{this.createRing(-50 * i);});
        }
    }

    createRing(durationMod)
    {
        let ring = this.scene.add.graphics({lineStyle: { width: 5, color: 0xffffff }});
        ring.setPosition(this.scene.mid.x + 20, this.scene.mid.y + 140);
        let ellipse = new Phaser.Geom.Ellipse(0, 0, 50, 50);

        let ringDuration = 2000 + durationMod;
        let ringDistance = 1000;

        this.scene.addTween(ellipse, ringDuration, {width: ringDistance, onUpdate: ()=>{
            let normalizedTime = ellipse.width / ringDistance;
            ellipse.height = ellipse.width * .5;
            ring.alpha = Phaser.Math.Easing.Expo.Out(1-normalizedTime);
            ring.clear();
            ring.strokeEllipseShape(ellipse);
        }}, Phaser.Math.Easing.Quadratic.Out);
    }

    animateRichPig()
    {
        this.animateRegular();

        let coinFrames = ["dimeAnim", "quarterAnim", "pennyAnim", "pennyAnim", "nickelAnim"];
        let pos = [
            {x: this.scene.mid.x + 20, y: this.scene.mid.y + 100},
            {x: this.scene.mid.x + 60, y: this.scene.mid.y + 100},
            {x: this.scene.mid.x + -20, y: this.scene.mid.y + 100},
            {x: this.scene.mid.x + 10, y: this.scene.mid.y + 90},
            {x: this.scene.mid.x + 50, y: this.scene.mid.y + 100},
        ];
        let frames = [11, 10, 11, 10, 12];
        let coins = [];
        let scales = [gameData.coinData.dime.scale, gameData.coinData.quarter.scale, gameData.coinData.penny.scale, gameData.coinData.penny.scale, gameData.coinData.nickel.scale];
        let angles = [0, 5, -10, 0, 8];

        for(let i = 0; i < coinFrames.length; i++)
        {
            let coin = this.scene.addSprite(pos[i].x, -300, coinFrames[i]);
            this.scene.addDelay(i * 50, ()=>{
                this.scene.addTween(coin, 1200, {y: pos[i].y}, "Bounce");
            });
            coin.anims.stop();
            coin.setScale(scales[i]);
            coin.setFrameIndex(frames[i]);
            coin.setAngle(angles[i]);
            coins.push(coin);
        }
        
        this.scene.addDelay(3200, ()=>{
            for(let i = 0; i < coins.length; i++)
            {
                coins[i].destroy();
            }
        });
    }

    animateRegular()
    {
        this.pig.spine.setPosition(this.pigData.pigPos.x, this.pigData.pigPos.y);
        this.pig.play(this.pigData.animation, false, ()=>{ this.onComplete(); });
    }

    animateNinjaPig()
    {
        this.pig.play(this.pigData.animation, true);
        this.pig.spine.setPosition(this.pigData.pigPos.x, this.pigData.pigPos.y);
        this.pig.spine.alpha = 0;
        this.pig.shadowSpine.alpha = 0;
        this.pig.stop();

        //console.log(this.scene.cache);

        this.scene.addDelay(500, ()=>{
            let smoke = this.scene.addSprite(this.scene.mid.x + 9, this.scene.mid.y - 13, "ninjaAnim");
            smoke.setScale(.82);
            smoke.setDepth(4);
            smoke.addListenerToFrame(6, ()=>{
                this.pig.spine.alpha = 1;
                this.pig.shadowSpine.alpha = 1;
            });
            smoke.addListenerToFrame(17, ()=>{
                this.scene.addDelay(0, ()=>{smoke.destroy();});
                this.pig.play(this.pigData.animation, false, ()=>{
                    this.onComplete();
                });
                this.throwShuricken();
            });
        });
    }

    throwShuricken()
    {
        let shurickenCont = this.scene.add.container(this.scene.mid.x + 135, this.scene.mid.y + 190);
        let shuricken = this.scene.addImage(0, 0, "BGElmnts_NinjaStr", shurickenCont);
        shurickenCont.setDepth(4);
        shurickenCont.setScale(0);
        this.scene.addTween(shurickenCont, 100, { scaleX: .5, scaleY: .2, delay: 200 }, null);
        this.scene.addTween(shurickenCont, 400, { x: 1200, delay: 200 }, null);
        this.scene.addTween(shuricken, 300, { angle: 360, repeat: -1 }, null);
    }

    animateFlyingPig()
    {
        this.pig.play(this.pigData.animation, true);
        this.pig.spine.setPosition(-360, this.pigData.pigPos.y);

        this.scene.addTween(this.pig.spine, 4000, {x: this.pigData.pigPos.x}, Phaser.Math.Linear.Linear, ()=>{
            this.onComplete();
            this.pig.stop();
        });
    }

    animateThiefPig()
    {
        let overlay = this.scene.addRect(0, 0, this.scene.size.width, this.scene.size.height, 0x000000);
        let spotlight = this.scene.addImage(200, 200, "spotlight");
        spotlight.visible = false;

        this.pig.spine.alpha = 0;
        this.pig.shadowSpine.alpha = 0;

        overlay.mask = new Phaser.Display.Masks.BitmapMask(this.scene, spotlight);
        overlay.mask.invertAlpha = true;
        overlay.alpha = 0;
        overlay.setDepth(1);

        this.scene.addTween(overlay, 500, {alpha: 1, delay: 1200}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.scene.addTween(spotlight, 800, {x: 700, scaleX: .6, scaleY: .6}, Phaser.Math.Easing.Sine.InOut, ()=>{
                this.scene.addTween(spotlight, 800, {x: 200, y: 600}, Phaser.Math.Easing.Sine.InOut, ()=>{
                    this.scene.addTween(spotlight, 800, {x: 900}, Phaser.Math.Easing.Sine.InOut, ()=>{
                        this.pig.spine.alpha = 1;
                        this.pig.shadowSpine.alpha = .4;
                        this.pig.spine.setPosition(this.pigData.pigPos.x, this.pigData.pigPos.y);
                        this.scene.addTween(overlay, 800, {alpha: 0}, Phaser.Math.Easing.Sine.In);
                        this.pig.play("Thief_Intro", false, ()=>{
                            this.onComplete();
                        }, 1);
                        this.scene.addTween(spotlight, 800, {x: this.scene.mid.x, y: this.scene.mid.y, scaleX: 2, scaleY: 2}, Phaser.Math.Easing.Sine.InOut);
                    });
                });
            });
        });
    }
}